module.exports = __webpack_public_path__ + "img/ст_Старощербиновская_НЗТ.b81352ed.png";